import { EventRegister } from "@common/events/event-register"

export const registerEventListeners: EventRegister = (_eventBus) => {
  return
}
